var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getAppliedSalesTax)?_c('h3',{staticClass:"text-body-1"},[_vm._v("Sales Tax ("+_vm._s(_vm.getTheCart.sales_tax)+"%) : "+_vm._s(_vm.getTheCart.sales_tax_formatted))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }